import { Pipe, PipeTransform } from '@angular/core';
import Decimal from 'decimal.js';

@Pipe({
  name: 'decimalCeiling'
})
export class DecimalCeilingPipe implements PipeTransform {

  transform(value: any): string {
    return new Decimal(value).ceil().toFixed(0);
  }

}
